import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {endpoints} from '../../../core/configs/endpoints';

@Injectable({providedIn: 'root'})
export class LanguageApiService {
  private readonly _httpClient = inject(HttpClient);

  public loadLanguages(): Observable<any> {
    return this._httpClient.get(endpoints.utilities.language);
  }

  public setLanguage(languageCode: string): Observable<any> {
    return this._httpClient.post(endpoints.user.lang, {
      languageCode
    });
  }
}
